import _Rate from './Rate';

import './style/index.js';

export type { RateProps } from './Rate';
export * from './type';

export const Rate = _Rate;
export default Rate;
